import React from 'react'
import { ActionProgress } from '@ztechapps/webui.util'
import { useCheckoutContext } from '../index'

export const ProgressBar = () => {
  const context = useCheckoutContext()

  const [activePanel] = context.activePanel
  const checkoutSteps = context.checkoutSteps

  return (
    <ActionProgress activeStep={activePanel}>
      {checkoutSteps.map(({ progress: Progress, itemKey }) => (
        <React.Fragment key={itemKey}>{<Progress />}</React.Fragment>
      ))}
    </ActionProgress>
  )
}
